<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

import router from "@/router";
import RadioBox from "@/components/radio-box";
import DigitalModal from "@/components/packages/digital-modal";
import PrintModal from "@/components/packages/print-modal";
import VideoModal from "@/components/packages/video-modal";

import {
  required,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  components: {
    RadioBox,
    Multiselect,
    DigitalModal,
    PrintModal,
    VideoModal
  },
  props: {
    update: {
      type: Boolean,
      default: false
    },
    package: {
      type: Object,
      required: false
    }
  },
  async mounted() {
    this.apiGet(`/mastheads`, {}, true).then((data) => {
      this.mastheadOptions = data.data;
    }).catch((error) => {
      this.$store.dispatch('layout/addPageError', error);
    })

    if (this.package && this.update) {
      this.form.landingPageAddedValue  = this.package.landingPageAddedValue
      this.form.landingPageMandatory = this.package.landingPageMandatory
      this.form.extraLocationsTargetingEnabled = this.package.extraLocationsTargetingEnabled
      this.form.extraPostcodesTargetingEnabled = this.package.extraPostcodesTargetingEnabled
      this.form.level = this.package.level
      this.form.masthead = this.package.masthead.id
      this.form.objective = this.package.objective
      this.form.pongrassDistributionCodeEid = this.package.pongrassDistributionCodeEid
      this.form.signifiPackageEid = this.package.signifiPackageEid
      this.form.type = this.package.type
      this.form.weeksDuration = this.package.weeksDuration

      this.form.digitalChannels = this.package.digitalChannels
      this.form.digitalPrice = this.package.digitalPrice
      this.form.impressions = this.package.impressions
      this.digitalDetail = {
        digitalChannels: this.form.digitalChannels,
        digitalPrice: this.form.digitalPrice,
        impressions: this.form.impressions,
      }
      this.form.digitalAddedValue = this.package.digitalAddedValue

      this.form.earlyGeneralNews = this.package.earlyGeneralNews
      this.form.insertionsPerWeek = this.package.insertionsPerWeek
      this.form.printPrice = this.package.printPrice
      this.form.printSize = this.package.printSize
      this.form.weeksDuration = this.package.weeksDuration
      this.printDetail = {
        earlyGeneralNews: this.form.earlyGeneralNews,
        insertionsPerWeek: this.form.insertionsPerWeek,
        printPrice: this.form.printPrice,
        printSize: this.form.printSize,
      }
      this.form.printAddedValue = this.package.printAddedValue

      this.form.impressions = this.package.impressions
      this.form.videoPrice = this.package.videoPrice
      this.videoDetail = {
        impressions: this.form.impressions,
        videoPrice: this.form.videoPrice,
      }
    }
  },
  data () {
    return this.initialState();
  },
  validations: {
    form: {
      level: { required },
      type: { required },
      masthead: { required },
      objective: { required },
      landingPageMandatory: { required },
      extraLocationsTargetingEnabled: { required },
      extraPostcodesTargetingEnabled: { required },
      signifiPackageEid: { required },
      pongrassDistributionCodeEid: { required },
      weeksDuration: { required },
    },
    digitalDetail: {
      required: requiredIf(function() {
        return this.form.type && this.form.type === 'Print & digital' || this.form.type === 'Digital'
      })
    },
    printDetail: {
      required: requiredIf(function() {
        return this.form.type && this.form.type === 'Print & digital'
      })
    },
    videoDetail: {
      required: requiredIf(function() {
        return this.form.type && this.form.type === 'Video'
      })
    },
  },
  methods: {
    initialState() {
      return {
        creating: false,
        mastheadOptions: [],
        levelOptions: [
          'Diamond',
          'Gold',
          'Platinum',
          'Silver',
        ],
        hasError: false,
        errors: null,
        type: null,
        submitted: false,
        form: {
          landingPageMandatory: false,
          extraLocationsTargetingEnabled: false,
          extraPostcodesTargetingEnabled: false,
          masthead: '',
          level: '',
          objective: '',
          type: '',
          signifiPackageEid: '',
          pongrassDistributionCodeEid: '',
          landingPageAddedValue: null,
          digitalChannels: [],
          impressions: '',
          digitalPrice: '',
          printAddedValue: null,
          digitalAddedValue: null,
          earlyGeneralNews: '',
          printPrice: '',
          printSize: '',
          weeksDuration: null
        },
        digitalDetail: null,
        printDetail: null,
        videoDetail: null
      }
    },
    reset() {
      Object.assign(this.$data, this.initialState());

      this.apiGet(`/mastheads`, {}, true).then((data) => {
        this.mastheadOptions = data.data;
      }).catch((error) => {
        this.$store.dispatch('layout/addPageError', error);
      })
    },
    handleUpdate(status) {
      this.submitted = true;

      this.$v.form.$touch();
      this.$v.printDetail.$touch();
      this.$v.digitalDetail.$touch();
      this.$v.videoDetail.$touch();

      if (!this.$v.form.$invalid && !this.$v.printDetail.$invalid && !this.$v.digitalDetail.$invalid && !this.$v.videoDetail.$invalid) {
        this.type = 'update';
        this.creating = true;

        this.apiPatch(`/packages/${this.package.id}`, { ...this.form, status }).then(() => {
          this.creating = false;
          Swal.fire({
            title: `Package for masthead ${this.mastheadValue.name} successfully updated`,
            icon: 'success',
            confirmButtonText: 'Back Home',
            confirmButtonColor: "#1D99C7",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(result => {
            if (result.value) {
              router.push({ path: '/packages' })
            }
          });
        }).catch((error) => {
          this.creating = false;

          if (error) {
            this.hasError = true;
            this.errors = error.response ? error.response.data.error.message : null;
          }
        })
      }
    },
    handleCreate(status) {
      this.submitted = true;

      this.$v.form.$touch();
      this.$v.printDetail.$touch();
      this.$v.digitalDetail.$touch();
      this.$v.videoDetail.$touch();

      if (!this.$v.form.$invalid && !this.$v.printDetail.$invalid && !this.$v.digitalDetail.$invalid && !this.$v.videoDetail.$invalid) {
        this.type = 'create'
        this.creating = true
        
        this.apiPost(`/packages`, { ...this.form, status }).then(() => {
          this.creating = false;
          Swal.fire({
            title: `Package for masthead ${this.mastheadValue.name} successfully added`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Add Another',
            cancelButtonText: 'Back Home',
            confirmButtonColor: "#1D99C7",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(result => {
            if (result.value) {
              this.reset();
              Swal.close();
            } else {
              router.push({ path: '/packages' });
            }
          });
        }).catch((error) => {
          this.creating = false;

          if (error) {
            this.hasError = true;
            this.errors = error.response ? error.response.data.error.message : null;
          }
        })
      }
    },
    handleDigitalModalSubmit({ data, cancel }) {
      Object.assign(this.form, data);

      this.digitalDetail = data;

      cancel();
    },
    handlePrintModalSubmit({ data, cancel }) {
      Object.assign(this.form, data);

      this.printDetail = data;

      cancel();
    },
    handleVideoModalSubmit({ data, cancel }) {
      Object.assign(this.form, data);

      this.videoDetail = data;

      cancel();
    },
    handleMastheadSelect({ id }) {
      this.form.masthead = id;

      this.form.type = '';
    },
    hasType(type) {
      const masthead = this.mastheadOptions.find((masthead) => masthead.id === this.form.masthead);

      if (masthead && masthead.packageTypes.length) {
       return masthead.packageTypes.find((packageType) => packageType === type);
      }
    },
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    mastheadValue() {
      return this.mastheadOptions.find((masthead) => masthead.id === this.form.masthead);
    },
  }
}

</script>

<template>
  <div class="row">
    <div class="col-12 col-md-3">
      <div class="card">
        <div class="card-body">
          <h3>Package Configuration</h3>
          <p>Add and Manage the Packages that Advantage offers to Advertisers. Configure Digital and Print Packages across all Mastheads including configuration, pricing and value benefits for each campaign option.</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-9">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-xl-8">
              <b-form>
                <b-form-group>
                  <label for="masthead" class="card-title">Masthead</label>
                  <p>Select masthead for this package</p>
                  <multiselect
                    :class="{ 'is-invalid': submitted && $v.form.masthead.$error }"
                    :options="mastheadOptions"
                    :value="mastheadValue"
                    @select="handleMastheadSelect"
                    deselect-label=""
                    label="name"
                    select-label=""
                    track-by="id"
                  ></multiselect>
                  <div v-if="submitted && $v.form.masthead.$error" class="invalid-feedback">
                    <span v-if="!$v.form.masthead.required">This value is required.</span>
                  </div>
                </b-form-group>
                <div class="row">
                  <div class="col-12 col-md-12">
                    <b-form-group>
                      <label for="type" class="card-title">Type</label>
                      <p>Please select one of the following Package Configurations</p>
                      <div class="row" :class="{ 'is-invalid': submitted && $v.form.type.$error }">
                        <div class="col-12 col-md-4">
                          <radio-box
                            :disabled="!form.masthead || !hasType('Digital')"
                            title="Digital"
                            icon="bxs-pointer"
                            text="Package will include only Digital Channels."
                            id="digital"
                            name="type"
                            value="Digital"
                            v-model="form.type"
                          />
                        </div>
                        <div class="col-12 col-md-4">
                          <radio-box
                            :disabled="!form.masthead || !hasType('Print & digital')"
                            title="Print & digital"
                            icon="bxs-news"
                            text="Package will include both Print & digital Channels."
                            id="printDigital"
                            name="type"
                            value="Print & digital"
                            v-model="form.type"
                          />
                        </div>
                        <div class="col-12 col-md-4">
                          <radio-box
                            :disabled="!form.masthead || !hasType('Video')"
                            title="Video"
                            icon="bxs-video"
                            text="Package will include only Video Channels."
                            id="video"
                            name="type"
                            value="Video"
                            v-model="form.type"
                          />
                        </div>
                      </div>
                      <div v-if="submitted && $v.form.type.$error" class="invalid-feedback">
                        <span v-if="!$v.form.type.required">This value is required.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-9">
                    <b-form-group>
                      <label for="objective" class="card-title">Objective</label>
                      <p>Please select one of the following Campaign Objectives</p>
                      <div class="row" :class="{ 'is-invalid': submitted && $v.form.objective.$error }">
                        <div class="col-12 col-md-6">
                          <radio-box
                            title="Awareness"
                            icon="bxs-user"
                            text="Drive Reach and Awareness"
                            id="awareness"
                            name="objective"
                            value="Awareness"
                            v-model="form.objective"
                          />
                        </div>
                      <div class="col-12 col-md-6">
                          <radio-box
                            title="Leads"
                            icon="bxs-phone"
                            text="Drive Actions including Leads and Calls"
                            id="leads"
                            name="leads"
                            value="Leads"
                            v-model="form.objective"
                          />
                        </div>
                      </div>
                      <div v-if="submitted && $v.form.objective.$error" class="invalid-feedback">
                        <span v-if="!$v.form.objective.required">This value is required.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <b-form-group>
                  <label for="tier">Level</label>
                  <multiselect
                    :class="{ 'is-invalid': submitted && $v.form.level.$error }"
                    :options="levelOptions"
                    deselect-label=""
                    placeholder="Select Level"
                    select-label=""
                    v-model="form.level"
                  ></multiselect>
                  <div v-if="submitted && $v.form.level.$error" class="invalid-feedback">
                    <span v-if="!$v.form.level.required">This value is required.</span>
                  </div>
                </b-form-group>
                <b-form-group>
                  <label for="weeksDuration">Weeks Duration</label>
                  <b-input name="weeksDuration" id="weeksDuration" type="number" v-model="form.weeksDuration" placeholder="Enter weeks duration" :class="{ 'is-invalid': submitted && $v.form.weeksDuration.$error }" />
                  <div v-if="submitted && $v.form.weeksDuration.$error" class="invalid-feedback">
                    <span v-if="!$v.form.weeksDuration.required">This value is required.</span>
                  </div>
                </b-form-group>
                <label>Package Rules</label>
                <b-form-group v-if="!form.type || form.type === 'Digital' || form.type === 'Print & digital'">
                  <b-form-checkbox switch size="lg" v-model="form.landingPageMandatory" :class="{ 'is-invalid': submitted && $v.form.landingPageMandatory.$error }">Landing Page Mandatory</b-form-checkbox>
                  <div v-if="submitted && $v.form.landingPageMandatory.$error" class="invalid-feedback">
                    <span v-if="!$v.form.landingPageMandatory.required">This value is required.</span>
                  </div>
                </b-form-group>
                <b-form-group v-if="!form.type || form.type === 'Video'">
                  <b-form-checkbox switch size="lg" v-model="form.extraLocationsTargetingEnabled" :class="{ 'is-invalid': submitted && $v.form.extraLocationsTargetingEnabled.$error }">Enable state/location targeting</b-form-checkbox>
                  <div v-if="submitted && $v.form.extraLocationsTargetingEnabled.$error" class="invalid-feedback">
                    <span v-if="!$v.form.extraLocationsTargetingEnabled.required">This value is required.</span>
                  </div>
                </b-form-group>
                <b-form-group v-if="!form.type || form.type === 'Video'">
                  <b-form-checkbox switch size="lg" v-model="form.extraPostcodesTargetingEnabled" :class="{ 'is-invalid': submitted && $v.form.extraPostcodesTargetingEnabled.$error }">Enable extra postcode targeting (up to 10)</b-form-checkbox>
                  <div v-if="submitted && $v.form.extraPostcodesTargetingEnabled.$error" class="invalid-feedback">
                    <span v-if="!$v.form.extraPostcodesTargetingEnabled.required">This value is required.</span>
                  </div>
                </b-form-group>
                <div class="row mt-3" v-if="!form.type || form.type === 'Digital' || form.type === 'Print & digital'">
                  <div class="col-12 col-md-6">
                    <b-form-group>
                      <label for="landingPageAddedValue">Added Landing Page Value</label>
                      <b-form-input id="landingPageAddedValue" name="landingPageAddedValue" placeholder="Enter landing page added value" type="number" v-model="form.landingPageAddedValue" />
                    </b-form-group>
                  </div>
                </div>
                <b-form-group>
                  <label for="signifiId">Package ID</label>
                  <b-input name="signifiId" id="signifiId" type="text" v-model="form.signifiPackageEid" placeholder="Enter Package ID for DSP" :class="{ 'is-invalid': submitted && $v.form.signifiPackageEid.$error }" />
                  <div v-if="submitted && $v.form.signifiPackageEid.$error" class="invalid-feedback">
                    <span v-if="!$v.form.signifiPackageEid.required">This value is required.</span>
                  </div>
                </b-form-group>
                <b-form-group>
                  <label for="pongrassDistributionCodeEid">Pongrass Distribution Code</label>
                  <b-input
                    name="pongrassDistributionCodeEid"
                    id="pongrassDistributionCodeEid"
                    type="text"
                    v-model="form.pongrassDistributionCodeEid"
                    placeholder="Enter Pongrass Distribution Code"
                    :class="{ 'is-invalid': submitted && $v.form.pongrassDistributionCodeEid.$error }"
                  />
                  <div v-if="submitted && $v.form.pongrassDistributionCodeEid.$error" class="invalid-feedback">
                    <span v-if="!$v.form.pongrassDistributionCodeEid.required">This value is required.</span>
                  </div>
                </b-form-group>
                
                <div class="mt-4 mb-3" v-if="!form.type || form.type === 'Print & digital'">
                  <hr/>
                  <h5>Print Channel:</h5>
                  <div class="card bg-light mt-2" v-if="printDetail">
                    <div class="card-head">
                      <h5>Summary</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 col-lg-4">
                          <h6>Section</h6>
                          <p>{{ form.earlyGeneralNews }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Size</h6>
                          <p>{{ form.printSize }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Total Impacts</h6>
                          <p>{{ this.mastheadValue ? this.mastheadValue.impactsPerInsertion * this.form.weeksDuration * this.form.insertionsPerWeek : null | formatNumberWithCommas }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Average Readership</h6>
                          <p>{{ this.mastheadValue ? this.mastheadValue.averageReadership : null| formatNumberWithCommas }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Print Cost ex GST</h6>
                          <p>{{ form.printPrice | formatCurrency }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Insertions per week</h6>
                          <p>{{ form.insertionsPerWeek }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group v-if="printDetail">
                        <label for="printAddedValue">Added Print Value</label>
                        <b-form-input id="printAddedValue" name="printAddedValue" placeholder="Enter print added value" type="number" v-model="form.printAddedValue" />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-button
                      v-b-modal.print-modal
                      variant="primary"
                      class="w-lg mt-1"
                      :disabled="!form.type || !form.masthead"
                      :class="{ 'is-invalid': submitted && $v.printDetail.$error }"
                    >
                      <i class="bx bx-edit-alt font-size-16 align-middle mr-2" />
                      Configure Channel
                    </b-button>
                    <div v-if="submitted && $v.printDetail.$error" class="invalid-feedback ml-3 flex-1">
                      <span v-if="!$v.printDetail.required">You must configure the print channel</span>
                    </div>
                  </div>
                  <print-modal
                    v-if="(!this.update && form.masthead) || (this.update && this.form.type && this.form.type === 'Print & digital')"
                    @submit="handlePrintModalSubmit"
                    :print-detail="this.printDetail"
                    :masthead="this.mastheadValue"
                    :package="this.form"
                  />
                </div>

                <div class="mt-4 mb-3" v-if="!form.type || form.type === 'Digital' || form.type === 'Print & digital'">
                  <hr/>
                  <h5>Digital Channel:</h5>
                  <div class="card bg-light mt-2" v-if="digitalDetail">
                    <div class="card-head">
                      <h5>Summary</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 col-lg-4">
                          <h6>Channels</h6>
                          <p class="mb-1 text-capitalize" v-for="(item, index) in form.digitalChannels" :key="index">{{ item }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Number of impressions</h6>
                          <p>{{ form.impressions | formatNumberWithCommas }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                          <h6>Digital Cost ex GST</h6>
                          <p>{{ form.digitalPrice | formatCurrency }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group v-if="digitalDetail">
                        <label for="DigitalAddedValue">Added Digital Value</label>
                        <b-form-input id="DigitalAddedValue" name="DigitalAddedValue" placeholder="Enter digital added value" type="number" v-model="form.digitalAddedValue" />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-button
                      v-b-modal.digital-modal
                      variant="primary"
                      class="w-lg mt-1"
                      :disabled="!form.type || !form.masthead"
                      :class="{ 'is-invalid': submitted && $v.digitalDetail.$error }"
                    >
                      <i class="bx bx-edit-alt font-size-16 align-middle mr-2" />
                      Configure Channel
                    </b-button>
                    <div v-if="submitted && $v.digitalDetail.$error" class="invalid-feedback ml-3 flex-1">
                      <span v-if="!$v.digitalDetail.required">You must configure the digital channel</span>
                    </div>
                  </div>
                  <digital-modal
                    v-if="!this.update || (this.update && this.digitalDetail)"
                    @submit="handleDigitalModalSubmit"
                    :digital-detail="this.digitalDetail"
                    :package-type="this.form.type"
                  />
                </div>

                <div class="mt-4 mb-3" v-if="!form.type || form.type === 'Video'">
                  <hr/>
                  <h5>Video Channel:</h5>
                  <div class="card bg-light mt-2" v-if="videoDetail">
                    <div class="card-head">
                      <h5>Summary</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 col-lg-6">
                          <h6>Number of impressions</h6>
                          <p>{{ form.impressions | formatNumberWithCommas }}</p>
                        </div>
                        <div class="col-6 col-lg-6">
                          <h6>Video Cost ex GST</h6>
                          <p>{{ form.videoPrice | formatCurrency }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-button
                      v-b-modal.video-modal
                      variant="primary"
                      class="w-lg mt-1"
                      :disabled="!form.type || !form.masthead"
                      :class="{ 'is-invalid': submitted && $v.videoDetail.$error }"
                    >
                      <i class="bx bx-edit-alt font-size-16 align-middle mr-2" />
                      Configure Channel
                    </b-button>
                    <div v-if="submitted && $v.videoDetail.$error" class="invalid-feedback ml-3 flex-1">
                      <span v-if="!$v.videoDetail.required">You must configure the video channel</span>
                    </div>
                  </div>
                  <video-modal
                    v-if="!this.update || (this.update && this.videoDetail)"
                    @submit="handleVideoModalSubmit"
                    :video-detail="this.videoDetail"
                    :package-type="this.form.type"
                  />
                </div>
              </b-form>
            </div>
          </div>
        </div>
        <div v-if="this.currentUser.role !== 'ROLE_SALES_DIRECTOR'">
          <div class="card-footer card-footer--border bg-white"  v-if="(this.package && !this.package.deletedAt) || !this.package">
            <b-alert v-model="hasError" variant="danger" dismissible>Error - We are unable to {{ type }} this Package due to: {{ errors }}</b-alert>
            <div class=" d-flex justify-content-end">
              <b-button
                :disabled="this.creating"
                variant="dark"
                class="mr-3"
                @click="() => this.update ? handleUpdate(this.package.status) : handleCreate('Draft')">
                <i class="bx bxs-save font-size-16 align-middle mr-2"></i>
                {{ this.update ? 'Update' : 'Save as Draft' }}
              </b-button>
              <b-button
                v-if="this.package && this.package.status !== 'Active' || !this.package"
                :disabled="this.creating"
                variant="primary"
                class="w-md"
                @click="update ? handleUpdate('Active') : handleCreate('Active')">
                {{ this.update ? 'Update and Publish' : 'Create Package' }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>